import { TextField } from '@mui/material'
import React, { Fragment } from 'react'
import { TEXT_FIELD } from './constants'
import './TextField.css'

const ElmTextField = ({ size = TEXT_FIELD.SIZE.SMALL, children, ...props }) => {
  return (
    <TextField size={"small"} fullWidth {...props}
      sx={{
        "& .MuiInputBase-input": {
          paddingTop: "6.5px",
          paddingBottom: "6.5px",
        },
        "& .MuiInputAdornment-root.MuiInputAdornment-positionStart:has(button)": {
          marginLeft: '-8px',
          marginRight: '4px'
        },
        "& .MuiInputAdornment-root.MuiInputAdornment-positionStart": {
          marginLeft: '-4px'
        },
        // "& .MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
        //   marginRight: '-12px'
        // }
      }}
    >{children}</TextField>
  )
}

const ElmTextFieldLabel = ({ labelText, size = TEXT_FIELD.SIZE.SMALL, children, ...props }) => {
  const requiredMark = props?.valuereq === 'req' ? '*' : '';

  return (
    <div className={`text-field-wrapper`} >
      <label className='text-field-label'>{labelText}
        <span style={{ color: '#ee0033' }}>{requiredMark}</span>
      </label>
      <ElmTextField size={size} children={children} {...props} />
    </div>
  )
}

const TextFieldVMP = ({ labelText, size = TEXT_FIELD.SIZE.SMALL, children, ...props }) => {

  return (
    <Fragment>
      {labelText ? <ElmTextFieldLabel labelText={labelText} size={size} children={children} {...props} /> : <ElmTextField size={size} children={children} {...props} />}
    </Fragment>
  )
}

export default TextFieldVMP